import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const ContactInput = ({ value, onChange }) => {
  const handleChange = (field, fieldValue) => {
    onChange({
      ...value,
      [field]: fieldValue
    });
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Icon name="User" size={18} color="var(--color-accent)" strokeWidth={2} />
        <label className="text-sm font-caption font-medium text-foreground">
          Contact Information (vCard)
        </label>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="Full Name"
          type="text"
          value={value?.name || ''}
          onChange={(e) => handleChange('name', e?.target?.value)}
          placeholder="John Doe"
          required
        />

        <Input
          label="Phone Number"
          type="tel"
          value={value?.phone || ''}
          onChange={(e) => handleChange('phone', e?.target?.value)}
          placeholder="+1 (555) 123-4567"
        />
      </div>
      <Input
        label="Email Address"
        type="email"
        value={value?.email || ''}
        onChange={(e) => handleChange('email', e?.target?.value)}
        placeholder="john.doe@example.com"
      />
      <Input
        label="Company/Organization"
        type="text"
        value={value?.company || ''}
        onChange={(e) => handleChange('company', e?.target?.value)}
        placeholder="Acme Corporation"
      />
      <div className="space-y-2">
        <label className="text-sm font-caption font-medium text-foreground">
          Address
        </label>
        <textarea
          value={value?.address || ''}
          onChange={(e) => handleChange('address', e?.target?.value)}
          placeholder="123 Main Street, City, State, ZIP"
          rows={3}
          className="w-full px-4 py-3 rounded-lg border border-input bg-background text-foreground dark:text-white text-sm font-body resize-none focus:outline-none focus:ring-2 focus:ring-ring transition-smooth"
        />
      </div>
      <div className="flex items-start gap-2 p-3 rounded-lg bg-muted/30 border border-border">
        <Icon name="Info" size={16} color="var(--color-muted-foreground)" strokeWidth={2} className="mt-0.5 flex-shrink-0" />
        <p className="text-xs font-caption text-muted-foreground leading-relaxed">
          Scanning this QR code will allow users to save your contact information directly to their phone's address book.
        </p>
      </div>
    </div>
  );
};

export default ContactInput;